import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBackground } from '../models';

export const Background: FC<React.PropsWithChildren<TBackground>> = ({
    background: { color, gradient } = {},
    borderRadius,
    children,
    className,
    dataTestId,
    gradientOverImage,
    gradientUnderImage,
    image,
    styles,
}) => {
    const gradientOver = gradientOverImage ? `${gradientOverImage},` : '';
    const gradientUnder = gradientUnderImage ? `,${gradientUnderImage}` : '';

    const backgroundImage = image && `${gradientOver}url(${image})${gradientUnder}`;

    return (
        <div
            className={cn(styles.responsiveBackground, className, {
                [styles.borderRadius]: borderRadius,
            })}
            data-test-id={dataTestId}
            style={{
                backgroundImage: backgroundImage || gradient || undefined,
                backgroundColor: color,
            }}
        >
            {children}
        </div>
    );
};
